<shift-warning-tooltip
  [absenceWarning]="absenceWarning"
  [doubleRegistration]="doubleRegistration"
  [deviatesFromSchedule]="deviatesFromSchedule"
>
  <div *ngIf="absenceWarning">{{ 'Already absent' | translate }}</div>
  <div *ngIf="doubleRegistration">{{ 'Overlapping registration' | translate }}</div>
  <div *ngIf="deviatesFromSchedule">{{ 'Deviates from schedule' | translate }}</div>
</shift-warning-tooltip>
